import { render, staticRenderFns } from "./UnitList.vue?vue&type=template&id=2a142780&scoped=true"
import script from "./UnitList.vue?vue&type=script&lang=js"
export * from "./UnitList.vue?vue&type=script&lang=js"
import style0 from "./UnitList.vue?vue&type=style&index=0&id=2a142780&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a142780",
  null
  
)

export default component.exports